'use client';

import React from 'react';

type SubSectionHeaderHeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

interface SubSectionHeaderProps {
  title: string;
  description?: string;
  /** Semantic heading level; default `h2`. */
  as?: SubSectionHeaderHeadingLevel;
  /** Extra classes merged after the base `sub-heading-block` on `<header>`. */
  headerClassName?: string;
  /** Classes on the title element (none if omitted). */
  headingClassName?: string;
  /** Classes on the description `<p>` (none if omitted). */
  descriptionClassName?: string;
}

const SubSectionHeader: React.FC<SubSectionHeaderProps> = ({
  title,
  description,
  as: Component = 'h2',
  headerClassName,
  headingClassName,
  descriptionClassName,
}) => {
  const rootClass = ['sub-heading-block', headerClassName].filter(Boolean).join(' ').trim();
  const resolvedClass = headingClassName?.trim() ? headingClassName : undefined;

  return (
    <header className={rootClass}>
      <Component className={resolvedClass}>{title}</Component>
      {description ? <p className={descriptionClassName}>{description}</p> : null}
    </header>
  );
};

export type { SubSectionHeaderHeadingLevel, SubSectionHeaderProps };
export default SubSectionHeader;
